export default {
    login_register: 'Logga in/Registrera',
    booking_confirmation_title: 'Bokningsbekräftelse',
    booking_confirmation_body: 'Tack för din bokning. Se bekräftelsedetaljer nedan.',
    insurance_requirements_modal_disclaimer: `Genom att göra denna bokning bekräftar jag att: jag inte har haft några domar eller trafikbrott under de senaste 5 åren. Jag har inte fått något förslag avvisat, någon försäkring annullerad eller förnyelse nekad eller blivit ombedd att betala en högre premie eller fått några särskilda villkor av någon bilförsäkringsgivare. Jag har inte blivit diskvalificerad från att köra. Jag har inga pågående åtal eller polisutredningar. Jag har inga domar för stöld, bedrägeri eller oärlighet de senaste 5 åren. Jag har inte haft nedsatt syn eller hörsel (som inte korrigeras med glasögon eller hörapparat), hjärtsjukdom, diabetes, anfall eller någon fysisk eller psykisk funktionsnedsättning. Jag har inte haft några olyckor de senaste 5 åren. Klicka {0} om du inte uppfyller dessa krav.`,
    insurance_requirements_here: 'här',
    insurance_requirements: 'Jag har läst och förstått {0}',
    ir: 'Försäkringskrav',
    location: 'Plats',
    pickup_location: 'Upphämtningsplats',
    dropoff_location: 'Avlämningsplats',
    vehicle: 'Fordon',
    pickup_and_dropoff: 'Upphämtning och avlämning (lokal tid)',
    view_voucher: 'Visa voucher',
    identity_verification_body: 'Du måste verifiera din identitet innan du hämtar fordonet',
    identity_verification_title: 'Verifiera identitet',
    search_again: 'Sök igen',
    refrigerated: 'kyld',
    aircon_lower: 'ac',
    aircon: 'Luftkonditionering',
    refrigeration: 'Kyld',
    not_available: 'Drive & Go är för närvarande endast tillgängligt för personer med identitets- och körkortsdokument från följande länder.',
    check_if_included: 'Kontrollera om ditt land är inkluderat.',
    included_in_booking: 'Ingår i denna bokning',
    cdw_with_excess: 'CDW med självrisk',
    theft_protection: 'Stöldskydd med självrisk',
    risk_reduction: 'Riskreducering',
    free_extras: 'Du har rätt till två gratis tillval <br /> med denna bokning.',
    continue: 'Fortsätt',
    luggage_large_short_label: 'S',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'L',
    luggage_large_long_label: 'stor',
    luggage_medium_long_label: 'mellan',
    luggage_small_long_label: 'liten',
    fuel_unspecified_label: 'ospecificerat',
    transmission_manual_label: 'Manuell',
    transmission_automatic_label: 'Automat',
    make_a_booking: 'Gör en bokning',
    pickup_date: 'Upphämtningsdatum',
    dropoff_date: 'Avlämningsdatum',
    driver_age: 'Förare mellan 30 - 65',
    enter_driver_age: 'Ange förarens ålder',
    promo_code: 'Kampanjkod',
    search: 'Sök',
    dropoff_date_cannot_be_before_pickup_date: 'Avlämningsdatum kan inte vara före upphämtningsdatum',
    pickup_date_cannot_be_in_the_past: 'Upphämtningsdatum kan inte vara i det förflutna',
    pickup_time_cannot_be_in_the_past: 'Upphämtningstid kan inte vara i det förflutna',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Avlämningstid måste vara senare än upphämtningstid om det är samma dag',
    vehicle_filters: 'Fordonsfilter',
    reset: 'Återställ',
    transmission: 'Växellåda',
    all: 'Alla',
    manual: 'Manuell',
    auto: 'Automat',
    passengers: 'Passagerare',
    vehicle_type: 'Fordontyp',
    filter: 'Filtrera',
    vehicle_search: 'Fordonssökning',
    edit: 'Redigera',
    no_results: 'Inga resultat matchar dina filter.',
    small_cars: 'Små bilar',
    medium_cars: 'Mellanstora bilar',
    large_cars: 'Stora bilar',
    estate_cars: 'Kombi',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Skåpbilar',
    camper_vans: 'Husbilar',
    premium: 'Premium',
    unspecified: 'ospecificerat',
    large: 'stor',
    medium: 'mellan',
    small: 'liten',
    automatic: 'automat',
    you_have_been_refunded: 'Du har fått återbetalning.',
    please_customer_service: 'Kontakta vår kundtjänst för att boka.',
    contact_customer_service: 'Kontakta kundtjänst',
    booking_failed: 'Din bokning kunde inte behandlas denna gång.',
    summary: 'Sammanfattning',
    reforestation_and_protection: 'Stöd återplantering och skydd av regnskogen i hela Costa Rica',
    cost_of_rental: 'Hyreskostnad',
    to_pay_now: 'Att betala nu',
    greenheart_donation: 'Green Heart-donation',
    total_cost: 'Total hyreskostnad',
    tc_agreement: 'Jag har läst och förstått {0}.',
    tc: 'Villkor',
    receive_offers: 'Jag vill få specialerbjudanden via e-post.',
    donate: 'Ja, jag vill donera {amount}',
    pay_now: 'Betala {amount} nu',
    driver_details: 'Förarens uppgifter',
    complete_driver_details: 'Vänligen fyll i förarens uppgifter.',
    are_you_the_driver: 'Är du föraren?',
    have_an_account: 'Har du redan ett konto?',
    login: 'Logga in',
    or: 'eller',
    first_name: 'Förarens förnamn',
    last_name: 'Förarens efternamn',
    email: 'E-postadress',
    phone_number: 'Mobilnummer',
    unable_to_save_driver_information: 'Det gick inte att spara förarens uppgifter. Försök igen.',
    pay_online_now: 'Betala nu',
    day: 'Dag',
    choose_location: 'Välj plats',
    location_not_found: 'Tyvärr kunde vi inte hitta den plats du sökte.',
    add: 'Lägg till',
    remove: 'Ta bort',
    free_extra: 'Gratis tillval',
    free: 'GRATIS!',
    fast_track_notice: 'Dokumentkrav gäller för denna tjänst. Endast tillgängligt för personer med dokument från',
    complete_booking: 'Slutför bokning',
    choose_card: 'Välj ett kort eller lägg till ett nytt.',
    add_billing_details: 'Lägg till faktureringsuppgifter.',
    card_number: 'Kortnummer',
    card_holder_name: 'Kortinnehavarens namn',
    card_exp: 'MM / ÅÅ',
    card_cvc: 'CVC',
    save_card: 'Spara kort?',
    amount_charged: 'Ditt kort kommer att debiteras',
    payment_confirmation: 'Bekräfta bokning och betala',
    payment_methods: 'tillgängliga betalningsmetoder',
    use_saved_card: 'x använd sparat kort',
    use_different_card: '+ använd ett annat kort',
    book_now: 'Boka nu',
    minimum_age: 'Endast över {age} år',
    excess_liability: 'Självrisk',
    security_deposit: 'Säkerhetsdeposition',
    fuel_policy: 'Bränslepolicy',
    like_for_like: 'Lika för lika',
    full_to_full: 'Full till full',
    miles_per_rental: '{mileage} fria mil per hyra',
    km_per_rental: '{mileage} fria km per hyra',
    unlimited_mileage: 'Obegränsad körsträcka',
    unlimited_mileage_km: 'Obegränsade km',
    non_amendable: 'Kan ej ändras',
    non_refundable: 'Ej återbetalningsbar',
    free_cancellation_until: 'Gratis avbokning fram till',
    cancellation_in_line_with: 'Avbokning enligt',
    tcs: 'Villkor',
    free_extras_on_collection: 'Två gratis tillval vid upphämtning',
    glass_and_tyres_covered: 'Glas och däck täcks',
    number_of_passengers: 'Antal passagerare',
    number_of_bags: 'Antal väskor',
    fuel_type: 'Bränsletyp',
    co2: 'CO2',
    book_type: 'Boka {type}',
    processing: 'Bearbetar',
    actual_price: 'Faktiskt pris',
    tooltip: 'Pris i {currencyCode} är en uppskattning baserat på växelkurs, priset i {currency} är bindande.',
    deposit: 'Deposition',
    pay_online: 'Betala nu',
    pay_online_without_extras: 'Hyrespris',
    extras_on_arrival: 'Tillval vid ankomst',
    insurance_on_arrival: 'Riskreducering - betala vid ankomst',
    insurance_online: 'Riskreducering - betala nu',
    extras_online: 'Tillval - betala nu',
    green_heart_donation: 'Green Heart-donation',
    why_use_drive_and_go: 'Varför använda Drive & Go?',
    straight_to_car: 'Direkt till bilen',
    no_queues: 'Inga köer',
    self_checkout: 'Självbetjäning',
    cant_lose_key: 'Kan inte tappa bort nyckeln',
    online_id_check: 'Online ID-kontroll',
    phone_as_key: 'Telefon som nyckel',
    premiumplus_benefits_includes: 'Premium Plus+ förmåner ingår',
    book_drive_go: 'Boka Drive & Go',
    distance_allowance: 'Distansgräns',
    duration: 'Varaktighet',
    view_more_bookings: 'Visa fler bokningar',
    to_pay_on_arrival: 'Att betala vid ankomst',
    pay_on_arrival: 'Betala vid ankomst',
    unlimited: 'Obegränsat',
    return_date: 'Returdatum',
    postcode: 'Postnummer',
    country: 'Land',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go är för närvarande endast tillgängligt för personer med identitets- och körkortsdokument från följande länder:',
        drive_and_go_today: 'Drive & Go-bokning idag!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Varför använda Drive & Go?',
        straight_to_car: 'Direkt till bilen',
        no_queues: 'Inga köer',
        self_checkout: 'Självbetjäning',
        cannot_lose_the_key: 'Kan inte tappa bort nyckeln',
        online_id_check: 'Online ID-kontroll',
        phone_as_a_key: 'Telefon som nyckel',
        premium_plus_benefits_also_included: 'Premium Plus+ förmåner ingår',
        book_drive_and_go: 'Boka Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Tält och utrustning',
        quick_and_easy: 'Snabb och enkel att sätta upp',
        travel_freedom: 'Resefrihet',
        affordable_campervan_alternative: 'Prisvärt alternativ till husbil',
        lightweight_and_compact: 'Lätt och kompakt',
        fully_insured: 'Fullt försäkrad',
    },
    my_bookings: 'Min bokning',
    no_bookings: 'Ingen bokning',
    my_profile: 'Min profil',
    no_bookings_to_display: 'Ingen bokning att visa.',
    search_great_car_rental_deals: 'Sök bra hyrbilstilbud för din nästa resa.',
    odometer_at_collection: 'Mätarställning vid upphämtning',
    fuel_at_collection: 'Bränsle vid upphämtning',
    start_check_in: 'Starta incheckning',
    start_collection: 'Starta upphämtning',
    recent_bookings: 'Senaste bokning',
    damage: {
        updated_damage_report_submitted: 'En uppdaterad skadeanmälan har skickats in. En medlem av vårt kundtjänstteam kontaktar dig vid behov.',
        add_additional_damage: 'Lägg till ytterligare skada',
        you_may_report_additional_damage_up_to: 'Du kan rapportera ytterligare skada upp till 24 timmar efter upphämtning',
        specify_damage: 'Specificera skada',
        please_choose_the_area_and_type_of_damage: 'Välj område och typ av skada',
        type_of_damage: 'Typ av skada',
        is_this_more_than_5_cm: 'Är detta mer än 5 cm?',
        please_take_or_select_a_photo: 'Ta eller välj ett foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Ta ett foto så att skadan syns tydligt',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Vid behov kan du lägga till ytterligare ett foto, välj ikonen för att lägga till',
        save_image: 'Spara bild',
        save_images: 'Spara bilder',
        damage_saved_successfully: 'Skadan sparades',
        add_photo: 'Lägg till foto',
    },
    checkout: {
        start_collection: 'Starta upphämtning',
        collect_vehicle: 'Hämta fordon',
        we_will_let_you_know_the_details: 'Vi meddelar dig plats och detaljer för att hitta hyrbilen.',
        inspect: 'Inspektera',
        we_will_ask_for_four_photos_from_each_corner: 'Vi ber om fyra foton från varje hörn av fordonet samt eventuella nya skador som inte redan är listade.',
        fuel_and_milage: 'Bränsle & körsträcka',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Du bekräftar mätarställning och bränsle vid start av hyran.',
        sign: 'Signera',
        sign_the_rental_agreement: 'Signera hyresavtalet.',
        away_you_go: 'Trevlig resa',
        you_are_free_to_take_to_the_road: 'Du kan ge dig ut på vägen!',
        collect_your_vehicle: 'Hämta ditt fordon',
        get_directions: 'Få vägbeskrivning',
        hide_directions: 'Dölj vägbeskrivning',
        local_time: 'lokal tid',
        tel: 'Tel',
        getting_to_the_location: 'Vägbeskrivning till platsen',
        get_vehicle_details: 'Fordonets detaljer',
        view_map: 'Visa karta',
        unlock_vehicle_and_continue: 'Lås upp fordon & fortsätt',
        unable_to_connect_to_vehicle: 'Kan inte ansluta till fordonet',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Vi kunde inte ansluta till fordonet – kontrollera att du är vid rätt fordon och försök igen.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Vi kunde inte hitta fordonsbokningen. Försök igen senare.',
        odometer_and_fuel: 'Mätarställning & bränsle',
        odometer: 'Mätarställning',
        please_confirm_the_odometer_and_fuel_readings: 'Bekräfta om möjligt mätarställning och bränsle.',
        the_odometer_field_is_required: 'Fältet mätarställning är obligatoriskt',
        and_must_be_greater_than_the_checkout_odometer: 'och måste vara större än mätarställningen vid upphämtning',
        confirm: 'Bekräfta',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Ta ett foto från varje hörn av fordonet',
        pre_existing_damage: 'Befintlig skada',
        no_pre_existing_damage: 'Ingen befintlig skada.',
        new_damage: 'Ny skada',
        add_additional_damage: 'lägg till ytterligare skada',
        no_new_damage_to_report: 'Ingen ny skada att rapportera',
        checkout_complete: 'Upphämtning klar',
        start_rental: 'Starta hyra',
        congratulations_name_it_is_time_to_take_to_the_road: 'Grattis {customer_name}, nu är det dags att ge dig ut på vägen!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Vi kan inte slutföra din fordonsupphämtning.',
        please_do_the_following: 'Vänligen gör följande',
        remove_all_belonging_and_lock_the_vehicle: 'Ta bort alla tillhörigheter och lås fordonet.',
        lock_vehicle: 'Lås fordon',
        once_you_have_contacted_customer_services: 'När du har kontaktat kundtjänst',
        vehicle_location: 'Fordonets plats',
        collect_your: 'Hämta din',
        from: 'Från',
        key_in_glove_box: 'din nyckel finns i handskfacket',

        keyholder: {
            not_detected: 'Nyckel ej upptäckt i nyckelhållaren',
            not_detected_please_try_again: 'Placera din nyckel i nyckelhållaren och försök igen.',

            not_installed: 'Nyckelhållare ej installerad',
            not_installed_please_contact_customer_service: 'Nyckelhållare är ej installerad, kontakta kundtjänst.',
        },
        keyring: {
            look_up_failed: 'Nyckelring hittades inte',
            look_up_failed_please_contact_customer_service: 'Nyckelring hittades inte, kontakta kundtjänst.',
        },
        key: {
            invalid: 'Nyckeln är ogiltig',
            invalid_please_contact_customer_service: 'Din nyckel är ogiltig, kontakta kundtjänst.',

            expired: 'Nyckeln har gått ut',
            expired__please_contact_customer_service: 'Din nyckel har gått ut, kontakta kundtjänst.',
        },
    },
    checkin: {
        start_check_in: 'Starta incheckning',
        vehicle_location: 'Fordonets plats',
        tell_us_where_you_have_parked: 'Berätta var du parkerade fordonet.',
        fuel_and_milage: 'Bränsle & körsträcka',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Du bekräftar mätarställning och bränsle vid slutet av hyran.',
        inspect: 'Inspektera',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Vi ber om fyra foton från varje hörn av fordonet samt eventuella nya skador under hyran.',
        lock: 'Lås',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Kontrollera att du inte lämnat något och lås sedan fordonet.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Berätta var du parkerade fordonet',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'När fordonet är låst kan du inte låsa upp det igen.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, kontrollera att du inte lämnat något, lås fordonet och lämna tillbaka den fysiska nyckeln till nyckelhållaren om det behövs.',
        lock_vehicle: 'Lås fordon',
        complete_check_in: 'Slutför incheckning',
        inspection: 'Inspektion',
        complete_vehicle_check_in: 'Slutför fordonsincheckning',
        we_are_unable_to_complete_your_vehicle_check_in: 'Vi kan inte slutföra din fordonsincheckning.',
        please_contact_customer_services: 'Kontakta kundtjänst',
        once_you_have_contacted_customer_services: 'När du har kontaktat kundtjänst',
        please_amend_odometer_to_be_greater_than: 'Ändra mätarställningen till mer än {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Hyresavtal',
        agreement_between: 'Avtal mellan',
        and: 'och',
        sign_rental_agreement: 'Signera hyresavtal',
        i_have_read_and_understood_the_terms_and_conditions: 'Jag har läst och förstått villkoren och accepterar fordonets skick',
    },
    additional_options: 'Ytterligare tillval',
    booking_details: 'Bokningsdetaljer',
    price_for_x_days: 'Pris för {qty_of_days} dag | Pris för {qty_of_days} dagar',
    cancelled: 'Avbokad',
    upcoming: 'Kommande',
    active: 'Aktiv',
    full_insurance_no_deposit: 'Full försäkring & ingen deposition krävs',
    excess: '{amount} självrisk',
    deposit: '{amount} deposition',
    included_daily_distance: '{distance} {unit} per dag',
    miles: 'mil',
    kilometers: 'kilometer',
    collection_details_title: 'Upphämtningsdetaljer',
    collection_details_not_found: 'Inga upphämtningsdetaljer definierade för denna plats',
    free_cancellation: 'Gratis avbokning',
    no_deposit: 'Ingen deposition',
    benefit_from: 'Dra nytta av',
    for_only_per_day: 'För endast {price} per dag',
    upgrade_mee: 'UpgradeMee',
};
